import Vue from 'vue'
import Vuex from 'vuex'
import utils from 'js/bankrate-utilities'
import { merge, forEach, some } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: utils.isMobile(),

    // Inputs
    homeValue: 0,
    firstMortgageBalance: 0,
    homeEquityLoanBalance: 0,
    lienBalance: 0,

    // Results
    partialLTV: 0,
    cumulativeLTV: 0,

    // Errors
    errors: {
      homeValue: false,
      firstMortgageBalance: false,
      homeEquityLoanBalance: false,
      lienBalance: false
    },

    // Previous input
    previousUserInputs: {
      homeValue: 0,
      firstMortgageBalance: 0,
      homeEquityLoanBalance: 0,
      lienBalance: 0
    }
  },
  mutations: {
    updatePageState(state, payload) {
      state[payload.name] = payload.value
    },
    setPageErrors(state, payload) {
      let error = typeof payload.error === 'undefined' ? false : payload.error
      state.errors = merge(state.errors, { [payload.name]: error })
    },
    updatePreviousUserInputs(state) {
      forEach(state.previousUserInputs, (value, key) => {
        state.previousUserInputs[key] = state[key]
      })
    }
  },
  actions: {
    loadConfig({ state, commit }, config) {
      forEach(state, (value, key) => {
        if (typeof config[key] !== 'undefined' && config[key].default) {
          commit('updatePageState', { name: key, value: config[key].default })
        }
      })
    },
    setNumberValue({ commit }, payload) {
      commit('updatePageState', { name: payload.name, value: payload.value })
      commit('setPageErrors', { name: payload.name, error: payload.error })
    },
    calculate({ state, commit }) {
      commit('updatePreviousUserInputs')

      const partialLTV = 100 * (state.firstMortgageBalance / state.homeValue)
      const cumulativeLTV =
        (100 *
          (state.firstMortgageBalance +
            state.homeEquityLoanBalance +
            state.lienBalance)) /
        state.homeValue

      commit('updatePageState', { name: 'partialLTV', value: partialLTV })
      commit('updatePageState', { name: 'cumulativeLTV', value: cumulativeLTV })
    }
  },
  getters: {
    pageHasErrors(state) {
      return some(state.errors, item => item)
    },
    dataChanged(state) {
      return some(state.previousUserInputs, (value, key) => {
        return value !== state[key]
      })
    }
  }
})
